// client/src/routes/app/properties/$propertyId/investment.tsx — SCR-PROP-003 tab
// „Investiție & credit" · PROP-004 (04 §8.3). Carries 05 PROP-004 criterion 2's total.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { InvestmentTab } from '@/features/properties/InvestmentTab';
import { useProperty } from '@/features/properties/queries';

export const Route = createFileRoute('/app/properties/$propertyId/investment')({
  component: InvestmentScreen,
});

function InvestmentScreen() {
  const { propertyId } = Route.useParams();
  const property = useProperty(propertyId);

  if (property.isPending) return <LoadingState rows={3} />;
  if (property.isError) return <ErrorState error={property.error} onRetry={() => void property.refetch()} />;

  return <InvestmentTab property={property.data} />;
}
